import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { ITemplatePanelButtonHOCProps } from './types';
import { onClick } from './events/onClick';
import { TemplatePanelButton } from '../../components/TemplatePanelButton/TemplatePanelButton';
import { ITemplatePanelButtonEvents, ITemplatePanelButtonFields } from '../../components/TemplatePanelButton/types';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: ITemplatePanelButtonHOCProps
): ITemplatePanelButtonFields => {
    const sectionType = getSectionType(state, boardId, null, 'allowCreateBoard');
    const isDisallow = sectionType === ESettingsSectionType.DISALLOW;
    const isShow = (sectionType === ESettingsSectionType.DEFAULT || isDisallow);
    return {
        isShow,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { onClick: ownOnClick }: ITemplatePanelButtonHOCProps
): ITemplatePanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const TemplatePanelButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(TemplatePanelButton);
